const comments = [
  {
    id: 1,
    name: '吃瓜不嫌事大',
    time: '3分钟前',
    content: '这波爆料太猛了，我直接原地裂开！没想到ta私下是这样的，之前人设立得也太好了吧...坐等后续猛料！',
    likes: 2837,
    avatar: 'R',
    avatarBg: 'bg-primary-500',
  },
  {
    id: 2,
    name: '理性吃瓜群众',
    time: '15分钟前',
    content: '理性分析一波，这个时间线对不上的点太多了。建议等官方回应再下结论，不过这个证据链确实有点东西。',
    likes: 1652,
    avatar: '理',
    avatarBg: 'bg-accent-500',
  },
  {
    id: 3,
    name: '深夜八卦bot',
    time: '28分钟前',
    content: '作为圈内边缘人士说一句，这事比你们看到的复杂多了。A和B早就闹掰了，C只是导火索而已，细品。',
    likes: 3421,
    avatar: '八',
    avatarBg: 'bg-secondary-500',
  },
  {
    id: 4,
    name: '瓜田里的守望者',
    time: '42分钟前',
    content: '笑死，评论区比正文好看一百倍。各路神仙打架，我这种凡人就在旁边默默嗑瓜子好了。',
    likes: 1208,
    avatar: '瓜',
    avatarBg: 'bg-accent-600',
  },
  {
    id: 5,
    name: '真相挖掘机',
    time: '1小时前',
    content: '补充一个细节，大家注意看第三张截图里的聊天时间戳，跟官方声明里说的完全对不上。懂的都懂。',
    likes: 2891,
    avatar: '真',
    avatarBg: 'bg-primary-600',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
              读者热评
            </h2>
            <p className="text-sm text-foreground-500">瓜友们都在聊什么？来看看最新热评</p>
          </div>
          <div className="space-y-4">
            {comments.map((c) => (
              <div
                key={c.id}
                className="bg-background-50 border border-background-200/70 rounded-xl p-5 hover:border-primary-200 transition-colors duration-200"
              >
                <div className="flex items-start gap-4">
                  <div
                    className={`w-10 h-10 rounded-full ${c.avatarBg} flex items-center justify-center flex-shrink-0`}
                  >
                    <span className="text-white text-sm font-bold">{c.avatar}</span>
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 mb-1.5 flex-wrap">
                      <span className="text-sm font-semibold text-foreground-800">{c.name}</span>
                      <span className="text-xs text-foreground-400">{c.time}</span>
                    </div>
                    <p className="text-sm text-foreground-600 leading-relaxed mb-3">{c.content}</p>
                    <div className="flex items-center gap-4 text-xs text-foreground-400">
                      <button className="flex items-center gap-1 hover:text-primary-500 transition-colors cursor-pointer">
                        <i className="ri-thumb-up-line"></i>
                        <span>{c.likes.toLocaleString()}</span>
                      </button>
                      <button className="flex items-center gap-1 hover:text-primary-500 transition-colors cursor-pointer">
                        <i className="ri-chat-1-line"></i>
                        <span>回复</span>
                      </button>
                      <button className="flex items-center gap-1 hover:text-primary-500 transition-colors cursor-pointer">
                        <i className="ri-share-forward-line"></i>
                        <span>分享</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}